import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { UsersTable } from "../../UI/Users/UsersTable";

const UsersPanel = () => {
  return (
    <div>
      <PanelHead title="Users" />
      <PanelBody content={<UsersTable />} />
    </div>
  );
};

export default React.memo(UsersPanel);
